'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PrivacyToggle = require('./components/PrivacyToggle');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrivacyToggle).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/privacy-toggle/index.js
// module id = 511
// module chunks = 4